var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gd-1",
    d: "M10.35,44.5c-4.47-7.73-4.47-17.27,0-25s12.72-12.5,21.65-12.5,17.18,4.77,21.65,12.5,4.47,17.27,0,25-12.72,12.5-21.65,12.5-17.18-4.77-21.65-12.5ZM25.75,42.16c0,1.3,1.05,2.34,2.34,2.34h7.81c1.3,0,2.34-1.05,2.34-2.34s-1.05-2.34-2.34-2.34h-.78v-8.59c0-1.3-1.05-2.34-2.34-2.34h-4.69c-1.3,0-2.34,1.05-2.34,2.34s1.05,2.34,2.34,2.34h2.34v6.25h-2.34c-1.3,0-2.34,1.05-2.34,2.34ZM28.87,22.62c0,1.73,1.4,3.12,3.13,3.12s3.13-1.4,3.13-3.12-1.4-3.12-3.13-3.12-3.13,1.4-3.13,3.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameDetails);
export default __webpack_public_path__ + "static/media/gameDetails.2593ae03341b76bd90210f5b5efd1f96.svg";
export { ForwardRef as ReactComponent };